import { useEffect } from 'react';
import { SKIP_INIT_ROLES } from '../util/routing';
import { getDeviceStore } from '../stores/device_store';
import { AuthStore } from '../stores/auth_store';
import { autorun } from 'mobx';

export const useInitializeDeviceStore = (authStore: AuthStore): void => {
    useEffect(() => {
        const dispose = autorun(() => {
            if (!authStore.userId) return;
            if (SKIP_INIT_ROLES.includes(authStore.role)) {
                return;
            }

            getDeviceStore().initialize();
        });

        return () => dispose();
    }, [authStore.role, authStore.userId]);
};
